import React from 'react';
import aboutUsData from '../../data/about-us.json';

const team = aboutUsData.team;
const teamSection = aboutUsData.teamSection;

export default function OrganizingTeam() {
    return (
        <section className="au-team">
            <style>{`
                .au-team {
                    background: var(--eventflow-black);
                    padding: 100px 0;
                    position: relative;
                    overflow: hidden;
                }
                .au-team::before {
                    content: '';
                    position: absolute; inset: 0;
                    background: radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.1) 0%, transparent 55%);
                    pointer-events: none;
                }
                .au-team__grid {
                    display: grid;
                    grid-template-columns: repeat(3,1fr);
                    gap: 24px;
                    margin-top: 56px;
                }
                .au-team__card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 16px;
                    overflow: hidden;
                    transition: all 0.3s;
                    position: relative;
                }
                .au-team__card:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.3);
                    transform: translateY(-6px);
                    box-shadow: 0 24px 60px rgba(0,0,0,0.4);
                }
                /* top accent on hover */
                .au-team__card::before {
                    content: '';
                    position: absolute; top: 0; left: 0; right: 0;
                    height: 2px;
                    background: linear-gradient(90deg, var(--eventflow-base), var(--eventflow-primary));
                    opacity: 0;
                    transition: opacity 0.3s;
                }
                .au-team__card:hover::before { opacity: 1; }

                .au-team__img-wrap {
                    position: relative;
                    height: 240px;
                    overflow: hidden;
                }
                .au-team__img-wrap img {
                    width: 100%; height: 100%;
                    object-fit: cover;
                    filter: brightness(0.85) saturate(0.85);
                    transition: filter 0.4s, transform 0.4s;
                }
                .au-team__card:hover .au-team__img-wrap img {
                    filter: brightness(0.95) saturate(1.0);
                    transform: scale(1.05);
                }
                .au-team__img-placeholder {
                    width: 100%; height: 100%;
                    background: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .au-team__img-placeholder span {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 700;
                    color: #333;
                }
                /* overlay on image */
                .au-team__img-overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(to top, rgba(4,0,10,0.8) 0%, transparent 50%);
                }
                /* social icons on image */
                .au-team__socials {
                    position: absolute;
                    top: 14px; right: 14px;
                    display: flex; flex-direction: column; gap: 8px;
                    opacity: 0;
                    transform: translateX(10px);
                    transition: all 0.3s;
                }
                .au-team__card:hover .au-team__socials {
                    opacity: 1; transform: translateX(0);
                }
                .au-team__social {
                    width: 32px; height: 32px;
                    border-radius: 8px;
                    background: rgba(4,0,10,0.7);
                    border: 1px solid rgba(255,255,255,0.1);
                    display: flex; align-items: center; justify-content: center;
                    color: rgba(255,255,255,0.7);
                    font-size: 13px;
                    text-decoration: none;
                    transition: background 0.2s, color 0.2s;
                }
                .au-team__social:hover {
                    background: var(--eventflow-base);
                    color: #fff;
                    border-color: var(--eventflow-base);
                }

                .au-team__body { padding: 20px 22px 24px; }
                .au-team__role {
                    font-family: 'Courier New', monospace;
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 2px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 6px;
                }
                .au-team__name {
                    font-family: var(--eventflow-font);
                    font-size: 18px; font-weight: 800;
                    color: #fff; margin-bottom: 10px;
                }
                .au-team__bio {
                    font-family: var(--eventflow-font);
                    font-size: 13px; line-height: 1.65;
                    color: rgba(255,255,255,0.42); margin: 0;
                }

                /* volunteer strip */
                .au-team__volunteer {
                    margin-top: 56px;
                    background: rgba(var(--eventflow-base-rgb),0.05);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.15);
                    border-radius: 16px;
                    padding: 36px 40px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    flex-wrap: wrap;
                }
                .au-team__volunteer-text h4 {
                    font-family: var(--eventflow-font);
                    font-size: 22px; font-weight: 800;
                    color: #fff; margin-bottom: 6px;
                }
                .au-team__volunteer-text p {
                    font-size: 14px; color: rgba(255,255,255,0.45); margin: 0;
                }

                @media (max-width: 991px) { .au-team__grid { grid-template-columns: repeat(2,1fr); } }
                @media (max-width: 576px)  {
                    .au-team__grid { grid-template-columns: 1fr; }
                    .au-team__volunteer { padding: 24px 20px; }
                }
            `}</style>

            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                    <div className="au-sec-tag" style={{justifyContent:'center'}}>{teamSection.tag}</div>
                    <h2 className="au-sec-title">{teamSection.title} <span>{teamSection.titleAccent}</span></h2>
                    <p className="au-sec-sub">{teamSection.subtitle}</p>
                </div>

                <div className="au-team__grid wow fadeInUp" data-wow-delay="150ms">
                    {team.map((m, i) => (
                        <div className="au-team__card" key={i}>
                            <div className="au-team__img-wrap">
                                {m.img ? (
                                    <img src={m.img} alt={m.name} />
                                ) : (
                                    <div className="au-team__img-placeholder">
                                        <span>Your Image</span>
                                    </div>
                                )}
                                <div className="au-team__img-overlay" />
                                {(m.twitter || m.linkedin) && (
                                    <div className="au-team__socials">
                                        {m.twitter && m.twitter !== '#' && (
                                            <a href={m.twitter} className="au-team__social" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        )}
                                        {m.linkedin && m.linkedin !== '#' && (
                                            <a href={m.linkedin} className="au-team__social" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="au-team__body">
                                <div className="au-team__role">{m.role}</div>
                                <div className="au-team__name">{m.name}</div>
                                <p className="au-team__bio">{m.bio}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Volunteer CTA */}
                <div className="au-team__volunteer wow fadeInUp" data-wow-delay="200ms">
                    <div className="au-team__volunteer-text">
                        <h4>{teamSection.volunteerCta.title}</h4>
                        <p>{teamSection.volunteerCta.description}</p>
                    </div>
                    <a href={teamSection.volunteerCta.buttonLink} className="thm-btn">
                        {teamSection.volunteerCta.buttonText} <span className="icon-arrow-right" />
                    </a>
                </div>
            </div>
        </section>
    );
}
